import { render, staticRenderFns } from "./UserCards.vue?vue&type=template&id=f88876d8&scoped=true&"
import script from "./UserCards.vue?vue&type=script&lang=js&"
export * from "./UserCards.vue?vue&type=script&lang=js&"
import style0 from "./UserCards.vue?vue&type=style&index=0&id=f88876d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f88876d8",
  null
  
)

export default component.exports